<template>
    <v-container fluid class="initial-wrapper">

            <template v-if="loaded">
                <v-row class="mr-2 ml-0">
                    <TopBar />
                </v-row>
                <v-row class="ma-1">
                    <v-col cols="12" md="6" class="pr-md-2 pa-0">
                        <v-card
                            elevation="0"
                            class="pa-sm-4 border-radius-1 fill-height custom-card">
                            <HeadChallengeCard
                                @openDialog="openDialog"
                            />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-0 pl-md-2 mt-5 mt-md-0">
                        <v-card
                            elevation="0"
                            class="pa-sm-4 border-radius-1 custom-card">
                            <EventsSection />
                        </v-card>
                    </v-col>
                </v-row>
                <PrizeChallenge
                    :dialogVisible="dialogVisible"
                    @closeDialog="closeDialog"
                    @updateDialog="updateDialog"
                />
            </template>
        </v-container>
</template>
<script>
import { mapState } from 'vuex'
import PreMessageCard from './PreMessageCard.vue'
import challengeService from '../../services/challenge'
import initialReaderValidation from "../../mixins/InitialReaderValidation";
import TopBar from '@/components/home/TopBar.vue'
import HeadChallengeCard from './HeadChallengeCard.vue';
import EventsSection from '@/components/home/EventsSection.vue'
import PrizeChallenge from '@/components/challenge/PrizeChallenge.vue'

export default {
    data() {
        return {
            dialogVisible: false,
            modalActive: false,
            imgInfo: require('@/assets/img/categories/tecnologia-e-inventos.png'),
        }
    },
    props: ['title', 'text', 'points', 'beecoins', 'loaded'],
    components: {
        PreMessageCard,
        TopBar,
        HeadChallengeCard,
        EventsSection,
        PrizeChallenge
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            course: (state) => state.userData.user.course,
        }),
        widthCard() {
            return this.$vuetify.breakpoint.xs ||
                this.$vuetify.breakpoint.sm ||
                this.$vuetify.breakpoint.md
                ? '80vw'
                : '50vw'
        },
        heightCard() {
            return this.$vuetify.breakpoint.xs ||
                this.$vuetify.breakpoint.sm ||
                this.$vuetify.breakpoint.md
                ? '65vh'
                : '55vh'
        },
        beecoinTop1Size() {
            return {
                size:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '170px'
                        : '10vw',
                maxSize:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '170px'
                        : '10vw',
            }
        },
        beecoinTop2Size() {
            return {
                size:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '90px'
                        : '6vw',
                maxSize:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '90px'
                        : '6vw',
            }
        },
        beecoinsContentSize() {
            return {
                size:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '200px'
                        : '9vw',
                maxSize:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '200px'
                        : '9vw',
            }
        },
        buttonSize() {
            return {
                width:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '350px'
                        : '18vw',
                height:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '70px'
                        : '3vw',
            }
        },
    },
    methods: {
        initChallengeByUserId(id) {
            return new Promise((resolve) => {
                challengeService
                    .initTest(id, false, this.isInitialReader)
                    .then((response) => {
                        resolve({
                            ok: true,
                            data: response,
                        })
                    })
                    .catch((err) => {
                        console.error('error: ', err)
                        resolve({
                            ok: false,
                            error: err,
                        })
                    })
            })
        },
        openDialog() {
            this.dialogVisible = true;
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        updateDialog(value) {
            this.dialogVisible = value;
        }
    },
    mixins: [initialReaderValidation],
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Patua+One&display=swap');

.background {
    background-image: url('/img/wallpaper/maze.png');
    background-size: cover;
    width: auto;
    height: auto;
}

.form-content {
    width: 60%;
    height: 40vw;
    position: relative;
}

.form-item-content {
    position: absolute;
    width: 27vw;
    height: 25vw;
    left: 11.5vw;
    top: 7vw;
}

.bright-points {
    align-items: center;
    padding-left: 5%;
    color: #816ad6;
    margin-top: -4vh;
    margin-bottom: -4vh;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
    margin-top: -4vh;
    margin-bottom: -4vh;
}

/* Título escalable */
.form-title {
    color: #fff;
    font-size: clamp(24px, 5.5vw, 42px);
    font-weight: 700;
    line-height: 1.15;
    text-align: center;
    padding: 0 12px;
}

/* Texto introductorio */
.form-text {
    font-size: clamp(14px, 3.8vw, 22px);
    color: #fff;
    line-height: 1.35;
    text-align: center;
    max-width: 680px;
    padding: 0 16px;
    margin-left: auto;
    margin-right: auto;
}

/* Ajuste de iconos decorativos para que no se desplacen demasiado en pantallas pequeñas */
.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: clamp(40px, 12vh, 160px);
    left: clamp(10px, 5vw, 80px);
    max-width: 170px;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: clamp(50px, 14vh, 190px);
    left: clamp(6px, 2vw, 24px);
    max-width: 120px;
}

.text-beecoin {
    font-size: clamp(12px, 2.6vw, 16px);
}

.button-text {
    text-transform: none;
    font-size: clamp(14px, 3.5vw, 18px);
    font-weight: 600;
}

@media (max-width: 960px) {
    .beecoin-top-1 { bottom: 60px; left: 40px; }
    .beecoin-top-2 { bottom: 70px; left: 12px; }
}
@media (max-width: 600px) {
    .beecoin-top-1 { bottom: 40px; left: 24px; }
    .beecoin-top-2 { bottom: 52px; left: 8px; }
    .form-title { font-size: clamp(24px, 9vw, 36px); }
    .form-text { font-size: clamp(14px, 4.5vw, 20px); }
}

/* Padding lateral en mobile para evitar que la tarjeta toque los bordes de la pantalla */
@media (max-width: 600px) {
    .initial-wrapper { padding-left: 16px!important; padding-right: 16px!important; }
}
.custom-card{
    @media screen and (min-width: 600px) {
        box-shadow: 0px 0px 60px 0px #0000000D!important;
    }
}
</style>
